import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Terrain from "@material-ui/icons/Terrain";
import Weekend from "@material-ui/icons/Weekend";
import LocalAtm from "@material-ui/icons/LocalAtm";
import Devices from "@material-ui/icons/Devices";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import InfoArea from "../../../components/InfoArea/InfoArea.jsx";

import featuresStyle from "../../../assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.jsx";

import bgFeatures from "../../../assets/img/bgFeatures.jpg";

function FeaturesSection({ ...props }) {
  const { classes, ...rest } = props;
  return (
    <div {...rest}>
      <div
        className={classes.features5}
        style={{ backgroundImage: `url(${bgFeatures})` }}
      >
        <GridContainer>
          <GridItem
            xs={12}
            sm={8}
            md={8}
            className={`${classes.mlAuto} ${classes.mrAuto} ${
              classes.textCenter
            }`}
          >
            <h2 className={classes.title}>¿Por qué elegir a Vivamos el Campo?</h2>
          </GridItem>

          <div className={classes.container}>
            <GridContainer className={classes.gridContainer}>
              <GridItem xs={6} sm={3} className={classes.gridItem}>
                <InfoArea
                  vertical
                  className={classes.infoArea5}
                  icon={Terrain}
                  title="Destinos Únicos"
                  description={
                    <p>
                        Conoce lugares que te invitan a vivir una experiencia distinta.
                    </p>
                  }
                  iconColor="info"
                />
              </GridItem>
              <GridItem xs={6} sm={3} className={classes.gridItem}>
                <InfoArea
                  vertical
                  className={classes.infoArea5}
                  icon={Weekend}
                  title="Gratas sensaciones"
                  description={
                    <p>
                        Disfruta del descanso y turismo vivencial que ofrecen nuestros Alojamientos.
                    </p>
                  }
                  iconColor="danger"
                />
              </GridItem>
              <GridItem xs={6} sm={3} className={classes.gridItem}>
                <InfoArea
                  vertical
                  className={classes.infoArea5}
                  icon={LocalAtm}
                  title="Diferentes métodos de pago"
                  description={
                    <p>
                        Si no tienes tarjeta de crédito, no te preocupes, te ofrecemos más opciones.
                    </p>
                  }
                  iconColor="primary"
                />
              </GridItem>
              <GridItem xs={6} sm={3} className={classes.gridItem}>
                <InfoArea
                    vertical
                    className={classes.infoArea5}
                    icon={Devices}
                    title="Reservación Online"
                    description={
                      <p>
                          Aparta tu estadía desde cualquier lugar del mundo, con tan solo un click.
                      </p>
                    }
                    iconColor="primary"
                />
              </GridItem>
            </GridContainer>

          </div>
        </GridContainer>
      </div>
    </div>
  );
}

export default withStyles(featuresStyle)(FeaturesSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/FeaturesSection.jsx